import React from 'react';
import Slider from 'react-slick';

const ClientsSection = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 3 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <section className="clients-section style-two">
      <div className="sponsors-outer">
        <Slider {...settings} className="clients-carousel-two">
          {[1, 2, 3, 4, 5].map((i) => (
            <div className="slide-item" key={i}>
              <img src="/assets/images/resource/client.png" alt={`Client ${i}`} />
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default ClientsSection;